import { DrEntity } from './dr-entity';
import { DrObjectType, DrObject } from './dr-object';
import { View } from './view';

export class SavedSearchViewModel extends DrObject {

    model: Partial<SavedSearch>;

    constructor(value: Partial<SavedSearch>) {
        super(DrObjectType.SAVED_SEARCH);
        if (value) {
            this.model = value;
        }
    }
}

export class SavedSearch extends DrEntity {
    childSavedSearches: any[];
    corporaFilters: any[];
    creator: string;
    description: string;
    dynamicFolder: string;
    includeFamily: boolean;
    includeMetadata: boolean;
    includeSynonyms: boolean;
    generateReports: boolean;
    name: string;
    searchQuery: string;
    search1: any;
    targetViewHandle: string;
    view: View;
    archived: boolean;

    // additional UI fields
    searchTask: string;
    iconStringContent: string;
    xmlQuery: string;
    constructor(value?: Partial<SavedSearch>) {
        super(value);
        if (value) {
            Object.assign(this, value);
        }
    }
}
